import type { EditorThemeClasses } from 'lexical';

const NoteEditorTheme: EditorThemeClasses = {
  // Text formatting
  text: {
    bold: 'font-bold',
    italic: 'italic',
    underline: 'underline',
    strikethrough: 'line-through',
    code: 'rounded bg-muted px-1 py-0.5 font-mono text-[0.85em]',
  },

  // Paragraph
  paragraph: 'mb-2 last:mb-0',

  // Headings
  heading: {
    h1: 'text-2xl font-bold mb-4 mt-6 first:mt-0',
    h2: 'text-xl font-bold mb-3 mt-5 first:mt-0',
    h3: 'text-lg font-semibold mb-3 mt-4 first:mt-0',
    h4: 'text-base font-semibold mb-2 mt-3 first:mt-0',
    h5: 'text-sm font-semibold mb-2 mt-3 first:mt-0',
    h6: 'text-xs font-semibold mb-2 mt-2 first:mt-0',
  },

  // Lists
  list: {
    ul: 'list-disc list-inside ml-4 mb-2',
    ol: 'list-decimal list-inside ml-4 mb-2',
    checklist: 'list-none ml-0 pl-0 mb-2',
    listitem: 'mb-1',
    listitemChecked: 'editor-listitem-checked',
    listitemUnchecked: 'editor-listitem-unchecked',
    nested: {
      listitem: 'mb-0',
    },
  },

  // Links
  link: 'text-foreground underline underline-offset-2 hover:text-foreground/70 cursor-pointer',

  // Quote
  quote: 'border-l-2 border-border pl-4 italic text-muted-foreground my-4',

  // Code block
  code: 'block rounded-md bg-muted p-3 my-2 font-mono text-sm leading-snug overflow-x-auto whitespace-pre-wrap',

  // Horizontal rule
  hr: 'my-4 border-0 border-t border-border',

  // Tables
  table: 'border-collapse border border-border my-4 w-full text-sm',
  tableRow: '',
  tableCell: 'border border-border p-2 text-left align-top',
  tableCellHeader:
    'border border-border p-2 font-semibold bg-muted text-left align-top',

  // Mention chips
  mention: 'lexical-mention',
};

export default NoteEditorTheme;
